import React, { Component } from 'react'
import { connect } from 'react-redux'

import SmsOverLimit from './SmsOverLimit'
import SmsSettingsAlert from './SmsSettingsAlert'
import PremiumMember from './PremiumMember'
import PremiumCTA from './PremiumCTA'

const connected = connect(store => {
  return {
    premium: store.user.premium,
    premiumAmount: store.user.premiumAmount,
    smsUnderLimit: store.user.user.sms_under_limit,
    isAuthenticated: store.session.isAuthenticated
  }
})
export class PremiumAsk extends Component {
  premiumAmountChange = (e, { value }) => this.props.dispatch({ type: 'SET_PREMIUM_AMOUNT', payload: value })

  render() {
    const { premium, smsUnderLimit, isAuthenticated } = this.props

    return (
      <>
        {isAuthenticated && premium && !smsUnderLimit && <SmsOverLimit />}
        {isAuthenticated && premium && smsUnderLimit && <SmsSettingsAlert />}
        {premium && <PremiumMember />}
        {!premium && <PremiumCTA />}
      </>
    )
  }
}
export default connected(PremiumAsk)
